import React from "react";
import { useAppContext } from "../../../context/AppContext";
import Transition from "../../../components/Transition";
import { AnimatePresence } from "framer-motion";

export default function InfoPageLayout({ title, description, children }) {
    const { appData } = useAppContext();

    return (
        <div className="min-vh-100 d-flex flex-column">
            <header className="py-5 border-bottom">
                <div className="container">
                    <h1 className="display-5 fw-bold text-center">{title}</h1>
                    {description && (
                        <p className="text-center mt-2 fs-5">{description}</p>
                    )}
                </div>
            </header>

            <main className="flex-grow-1 py-5">
                <div className="container" style={{ maxWidth: "800px" }}>
                    <AnimatePresence mode="wait">
                        <Transition key={"info-page"}>
                            {children}
                        </Transition>
                    </AnimatePresence>
                </div>
            </main>

            <footer className=" py-4 mt-auto border-top text-center">
                <div className="container">
                    <small className="text-muted">
                        &copy; {new Date().getFullYear()} {title} · {appData?.name}. All rights reserved. <br />
                    </small>
                </div>
            </footer>
        </div>
    );
}